import React, { useMemo } from 'react';

import { requestCallback } from 'Services/api/payment';
import { useBraze } from 'Services/braze';
import { sendBrazeMotorwayPayEvent } from 'Services/braze/brazeEvents';
import usePaymentsMVPEnabled from 'Utilities/hooks/usePaymentsMVPEnabled';
import useUser from 'Utilities/hooks/useUser';

import DiscoverMWPay from './DiscoverMWPay';
import type { DiscoverMWPayProps } from './DiscoverMWPay.types';

// That's not Storybook component, that's a entry point for next.js page
export const DiscoverMWPayPage: React.FC = () => {
	useBraze({ eventFn: sendBrazeMotorwayPayEvent });

	const isPaymentsMVPEnabled = usePaymentsMVPEnabled();
	const { isLoggedOut } = useUser();

	const resolveDisplayAs = useMemo((): DiscoverMWPayProps['displayAs'] => {
		if (isLoggedOut) {
			return 'signedOut';
		}

		if (isPaymentsMVPEnabled) {
			return 'paymentsDealer';
		}

		return 'signedIn';
	}, [isLoggedOut, isPaymentsMVPEnabled]);

	return <DiscoverMWPay displayAs={resolveDisplayAs} requestCallbackCallback={requestCallback} />;
};
